import { render, staticRenderFns } from "./YtVideosTab.vue?vue&type=template&id=3c1b94d1&scoped=true&"
import script from "./YtVideosTab.vue?vue&type=script&lang=js&"
export * from "./YtVideosTab.vue?vue&type=script&lang=js&"
import style0 from "./YtVideosTab.vue?vue&type=style&index=0&id=3c1b94d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1b94d1",
  null
  
)

export default component.exports